import { AddRequestComponent } from './add-requesst/add-request.component';
import { CustomFormFieldsComponent } from './directives/custom-form-fields/custom-form-fields.component';
import { RequestTakeActionComponent } from './directives/request-take-action/request-take-action.component';
import { EditRequestComponent } from './edit-request/edit-request.component';
import { ViewRequestComponent } from './view-request/view-request.component';
import { RequestListComponent } from './view-request/request-list/request-list.component';
import { SingleRequestViewComponent } from './view-request/single-request-view/single-request-view.component';
import { RequestResponseViewComponent } from './view-request/request-response-view/request-response-view.component';
import { RequestFormPreviewComponent } from './directives/request-form-preview/request-form-preview.component';
import { CreateRequestMenuComponent } from './directives/create-request-menu/create-request-menu-component';


export const RequstDeclaration = [
    AddRequestComponent,
    ViewRequestComponent,
    EditRequestComponent,
    
    CustomFormFieldsComponent,
    RequestTakeActionComponent,
    RequestFormPreviewComponent,

    RequestListComponent,
    SingleRequestViewComponent,
    RequestResponseViewComponent,
    CreateRequestMenuComponent
];
